import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Container, Col, Row, Button, Modal } from "react-bootstrap";
import { Authorization } from "../../../Context/Authorization";
import Select from "react-select";

const Access = ({ show, onHide, setAccess }) => {
  const [states, setStates] = useState([]);
  const [circles, setCircles] = useState([]);
  const [divisions, setdivisions] = useState([]);
  const [ranges, setRanges] = useState([]);
  const [vfcData, setVfcData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCircle, setSelectedCircle] = useState([]);
  const [selecteddivision, setSelecteddivision] = useState([]);
  const [selectedRange, setSelectedRange] = useState([]);
  const [selectedVfc, setSelectedVfc] = useState([]);
  const [showStateOptions, setShowStateOptions] = useState(false);
  const [showCircleOptions, setShowCircleOptions] = useState(false);
  const [showdivisionOptions, setShowdivisionOptions] = useState(false);
  const [showRangeOptions, setShowRangeOptions] = useState(false);
  const [showVfcOptions, setShowVfcOptions] = useState(false);
  const [allSelectedCircles, setAllSelectedCircles] = useState([]);
  const [allSelectedDivisions, setAllSelectedDivisions] = useState([]);
  const [allSelectedRanges, setAllSelectedRanges] = useState([]);
  const [allSelectedVfcs, setAllSelectedVfcs] = useState([]);

  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const Config = Authorization();
        const [
          statesResponse,
          circlesResponse,
          divisionsResponse,
          rangesResponse,
          vfcsResponse,
        ] = await Promise.all([
          axios.get(`${Api}/api/states`, Config),
          axios.get(`${Api}/api/circles`, Config),
          axios.get(`${Api}/api/divisions`, Config),
          axios.get(`${Api}/api/ranges`, Config),
          axios.get(`${Api}/api/vfcs`, Config),
        ]);

        setStates(statesResponse.data);
        setCircles(circlesResponse.data);
        setdivisions(divisionsResponse.data);
        setRanges(rangesResponse.data);
        setVfcData(vfcsResponse.data.vfcs);
      } catch (err) {
        console.error("Error fetching data", err);
      }
    };

    fetchData();
  }, []);

  const handleStateChange = (event) => {
    const value = event.target.value;
    setSelectedState(value);
    setShowStateOptions(value !== "No");
    setShowCircleOptions(value !== "No" && value !== "All");
    setShowdivisionOptions(false);
    setShowRangeOptions(false);
    setShowVfcOptions(false);
  };

  const handleCircleChange = (selectedOptions) => {
    if (!selectedOptions) {
      setSelectedCircle([]);
      setAllSelectedCircles([]);
      setShowdivisionOptions(false);
      setShowRangeOptions(false);
      setShowVfcOptions(false);
      return;
    }

    let values;
    if (Array.isArray(selectedOptions)) {
      values = selectedOptions.map((opt) => opt.value);
    } else {
      values = [selectedOptions.value];
    }

    if (values.includes("All")) {
      setSelectedCircle("All");
      setAllSelectedCircles(
        Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions]
      );
      setShowdivisionOptions(true);
    } else {
      setSelectedCircle(values);
      setAllSelectedCircles([]);
      setShowdivisionOptions(values.length > 0);
    }

    setShowRangeOptions(false);
    setShowVfcOptions(false);
  };

  const handleDivisionChange = (selectedOptions) => {
    if (!selectedOptions) {
      setSelecteddivision([]);
      setAllSelectedDivisions([]);
      setShowRangeOptions(false);
      setShowVfcOptions(false);
      return;
    }

    let values;
    if (Array.isArray(selectedOptions)) {
      values = selectedOptions.map((opt) => opt.value);
    } else {
      values = [selectedOptions.value];
    }

    if (values.includes("All")) {
      setSelecteddivision("All");
      setAllSelectedDivisions(
        Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions]
      );
      setShowRangeOptions(true);
    } else {
      setSelecteddivision(values);
      setAllSelectedDivisions([]);
      setShowRangeOptions(values.length > 0);
    }

    setShowVfcOptions(false);
  };

  const handleRangeChange = (selectedOptions) => {
    if (!selectedOptions) {
      setSelectedRange([]);
      setAllSelectedRanges([]);
      setShowVfcOptions(false);
      return;
    }

    const values = Array.isArray(selectedOptions)
      ? selectedOptions.map((opt) => opt.value)
      : [selectedOptions.value];

    if (values.includes("All")) {
      setSelectedRange("All");
      setAllSelectedRanges(
        Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions]
      );
    } else {
      setSelectedRange(values);
      setAllSelectedRanges([]);
    }

    setShowVfcOptions(
      values.includes("Yes") || values.includes("All") || values.length > 0
    );
  };

  const handleVfcChange = (selectedOptions) => {
    if (!selectedOptions) {
      setSelectedVfc([]);
      setAllSelectedVfcs([]);
      return;
    }

    const values = Array.isArray(selectedOptions)
      ? selectedOptions.map((opt) => opt.value)
      : [selectedOptions.value];

    if (values.includes("All")) {
      setSelectedVfc("All");
      setAllSelectedVfcs(
        Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions]
      );
    } else {
      setSelectedVfc(values);
      setAllSelectedVfcs([]);
    }
  };

  const filtereddivisions =
    selectedCircle === "All"
      ? divisions
      : divisions.filter(
          (division) =>
            Array.isArray(selectedCircle) &&
            selectedCircle.includes(division.circleId.circleName)
        );

  const filteredRanges =
    selecteddivision === "All"
      ? ranges.filter((range) =>
          filtereddivisions.some(
            (division) => division._id === range.divisionId?._id
          )
        )
      : ranges.filter(
          (range) =>
            Array.isArray(selecteddivision) &&
            selecteddivision.includes(range.divisionId?.divisionName)
        );

  const filteredVfc =
    selectedRange === "All"
      ? vfcData.filter((vfc) =>
          allSelectedRanges.some(
            (range) => range.value === vfc.rangeId?.rangeName
          )
        )
      : vfcData.filter(
          (vfc) =>
            Array.isArray(selectedRange) &&
            selectedRange.includes(vfc.rangeId?.rangeName)
        );

  const handleSave = () => {
    const accessData = {
      stateId:
        selectedState === "All"
          ? states.map((s) => s._id)
          : [states.find((s) => s.stateName === selectedState)?._id],

      circleId:
        selectedCircle === "All"
          ? allSelectedCircles
              .map(
                (opt) => circles.find((c) => c.circleName === opt.value)?._id
              )
              .filter(Boolean)
          : circles
              .filter((circle) => selectedCircle.includes(circle.circleName))
              .map((circle) => circle._id),

      divisionId:
        selecteddivision === "All"
          ? allSelectedDivisions
              .map(
                (opt) =>
                  filtereddivisions.find((d) => d.divisionName === opt.value)
                    ?._id
              )
              .filter(Boolean)
          : filtereddivisions
              .filter((d) => selecteddivision.includes(d.divisionName))
              .map((d) => d._id),

      rangeId:
        selectedRange === "All"
          ? filteredRanges.map((r) => r._id)
          : filteredRanges
              .filter((range) => selectedRange.includes(range.rangeName))
              .map((range) => range._id),

      vfcId:
        selectedVfc === "All"
          ? filteredVfc.map((v) => v._id)
          : filteredVfc
              .filter((vfc) => selectedVfc.includes(vfc.vfcName))
              .map((vfc) => vfc._id),
    };

    setAccess(accessData);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-90w"
      aria-labelledby="division-modal-title"
      centered
    >
      <Modal.Header>
        <Modal.Title>Access Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Form>
            {/* State Selection */}
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>State</Form.Label>
                  <div className="input-container">
                    <Form.Control as="select" onChange={handleStateChange}>
                      <option>Select</option>
                      <option>All</option>
                      <option>Yes</option>
                      <option>No</option>
                    </Form.Control>
                  </div>
                </Form.Group>
              </Col>
              {showStateOptions && (
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Select State</Form.Label>
                    <div className="input-container">
                      <Form.Control
                        as="select"
                        value={selectedState}
                        onChange={(e) => setSelectedState(e.target.value)}
                      >
                        <option>Select</option>
                        <option>All</option>
                        {states.map((state) => (
                          <option key={state._id} value={state.stateName}>
                            {state.stateName}
                          </option>
                        ))}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>
              )}
            </Row>

            {/* Circle Selection */}
            {showCircleOptions && (
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Circle</Form.Label>
                    <div className="input-container">
                      <Form.Control as="select" onChange={handleCircleChange}>
                        <option>Select</option>
                        <option>All</option>
                        <option>Yes</option>
                        <option>No</option>
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>
                {showCircleOptions && (
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Select Circle</Form.Label>
                      <div className="input-container">
                        <Select
                          isMulti
                          value={
                            selectedCircle === "All"
                              ? circles
                                  .filter(
                                    (circle) =>
                                      circle.stateId.stateName ===
                                        selectedState || selectedState === "All"
                                  )
                                  .map((circle) => ({
                                    label: circle.circleName,
                                    value: circle.circleName,
                                  }))
                              : circles
                                  .filter((circle) =>
                                    Array.isArray(selectedCircle)
                                      ? selectedCircle.includes(
                                          circle.circleName
                                        )
                                      : false
                                  )
                                  .map((circle) => ({
                                    label: circle.circleName,
                                    value: circle.circleName,
                                  }))
                          }
                          onChange={handleCircleChange}
                          options={[
                            { label: "All", value: "All" },
                            ...circles
                              .filter(
                                (circle) =>
                                  circle.stateId.stateName === selectedState ||
                                  selectedState === "All"
                              )
                              .map((circle) => ({
                                label: circle.circleName,
                                value: circle.circleName,
                              })),
                          ]}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                )}
              </Row>
            )}

            {/* Division Selection */}
            {showdivisionOptions && (
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Division</Form.Label>
                    <div className="input-container">
                      <Form.Control as="select" onChange={handleDivisionChange}>
                        <option>Select</option>
                        <option>All</option>
                        <option>Yes</option>
                        <option>No</option>
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>
                {showdivisionOptions && (
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Select Division</Form.Label>
                      <div className="input-container">
                        <Select
                          isMulti
                          value={
                            selecteddivision === "All"
                              ? divisions
                                  .filter((division) =>
                                    selectedCircle === "All"
                                      ? true
                                      : Array.isArray(selectedCircle)
                                      ? selectedCircle.includes(
                                          division.circleId.circleName
                                        )
                                      : false
                                  )
                                  .map((division) => ({
                                    label: division.divisionName,
                                    value: division.divisionName,
                                  }))
                              : divisions
                                  .filter((division) =>
                                    Array.isArray(selecteddivision)
                                      ? selecteddivision.includes(
                                          division.divisionName
                                        )
                                      : false
                                  )
                                  .map((division) => ({
                                    label: division.divisionName,
                                    value: division.divisionName,
                                  }))
                          }
                          onChange={handleDivisionChange}
                          options={[
                            { label: "All", value: "All" },
                            ...divisions
                              .filter((division) =>
                                selectedCircle === "All"
                                  ? true
                                  : Array.isArray(selectedCircle)
                                  ? selectedCircle.includes(
                                      division.circleId.circleName
                                    )
                                  : false
                              )
                              .map((division) => ({
                                label: division.divisionName,
                                value: division.divisionName,
                              })),
                          ]}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                )}
              </Row>
            )}

            {/* Range Selection */}
            {showRangeOptions && (
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Range</Form.Label>
                    <div className="input-container">
                      <Form.Control as="select" onChange={handleRangeChange}>
                        <option>Select</option>
                        <option>All</option>
                        <option>Yes</option>
                        <option>No</option>
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>
                {showRangeOptions && (
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Select Range</Form.Label>
                      <div className="input-container">
                        <Select
                          isMulti
                          value={
                            selectedRange === "All"
                              ? ranges
                                  .filter((range) =>
                                    selecteddivision === "All"
                                      ? true
                                      : Array.isArray(selecteddivision)
                                      ? selecteddivision.includes(
                                          range.divisionId.divisionName
                                        )
                                      : false
                                  )
                                  .map((range) => ({
                                    label: range.rangeName,
                                    value: range.rangeName,
                                  }))
                              : ranges
                                  .filter((range) =>
                                    Array.isArray(selectedRange)
                                      ? selectedRange.includes(range.rangeName)
                                      : false
                                  )
                                  .map((range) => ({
                                    label: range.rangeName,
                                    value: range.rangeName,
                                  }))
                          }
                          onChange={handleRangeChange}
                          options={[
                            { label: "All", value: "All" },
                            ...ranges
                              .filter((range) =>
                                selecteddivision === "All"
                                  ? true
                                  : Array.isArray(selecteddivision)
                                  ? selecteddivision.includes(
                                      range.divisionId.divisionName
                                    )
                                  : false
                              )
                              .map((range) => ({
                                label: range.rangeName,
                                value: range.rangeName,
                              })),
                          ]}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                )}
              </Row>
            )}

            {/* VFC Selection */}
            {showVfcOptions && (
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>VFC</Form.Label>
                    <div className="input-container">
                      <Form.Control as="select" onChange={handleVfcChange}>
                        <option>Select</option>
                        <option>All</option>
                        <option>Yes</option>
                        <option>No</option>
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>
                {showVfcOptions && (
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Select VFC</Form.Label>
                      <div className="input-container">
                        <Select
                          isMulti
                          value={
                            selectedVfc === "All"
                              ? vfcData
                                  .filter((vfc) =>
                                    selectedRange === "All"
                                      ? true
                                      : Array.isArray(selectedRange)
                                      ? selectedRange.includes(
                                          vfc.rangeId.rangeName
                                        )
                                      : false
                                  )
                                  .map((vfc) => ({
                                    label: vfc.vfcName,
                                    value: vfc.vfcName,
                                  }))
                              : vfcData
                                  .filter((vfc) =>
                                    Array.isArray(selectedVfc)
                                      ? selectedVfc.includes(vfc.vfcName)
                                      : false
                                  )
                                  .map((vfc) => ({
                                    label: vfc.vfcName,
                                    value: vfc.vfcName,
                                  }))
                          }
                          onChange={handleVfcChange}
                          options={[
                            { label: "All", value: "All" },
                            ...vfcData
                              .filter((vfc) =>
                                selectedRange === "All"
                                  ? true
                                  : Array.isArray(selectedRange)
                                  ? selectedRange.includes(
                                      vfc.rangeId.rangeName
                                    )
                                  : false
                              )
                              .map((vfc) => ({
                                label: vfc.vfcName,
                                value: vfc.vfcName,
                              })),
                          ]}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                )}
              </Row>
            )}
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Access;
